import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { ErrorResponse } from '@/models/Error';
import postSignIn from '@/pages/SignIn/postSignIn';

export type SignInRequest = {
  user: {
    login: string;
    password: string;
    rememberMe?: boolean;
  };
};
type SignInFieldNames = keyof SignInRequest['user'];
export type SignInErrorResponse = ErrorResponse<SignInFieldNames> & { code?: 'unconfirmed_email' };

type UseSignInResult = UseMutationResult<AxiosResponse, AxiosError<SignInErrorResponse>, SignInRequest>;

export default (): UseSignInResult => {
  return useMutation<AxiosResponse, AxiosError<SignInErrorResponse>, SignInRequest>({
    mutationFn: (data) => postSignIn(data),
  });
};
